import type { ContentItem } from "@/lib/contentParsers/contentItemSchemas";
import {
  appendCtaKeyAndText,
  appendRedirectFields,
  collectNestedCtaFields,
  type CtaFieldSink,
} from "@/lib/contentParsers/contentItemCtaFields";
import {
  isButtonContentItem,
  isButtonOverlayContentItem,
  isConditionalCtaContentItem,
} from "@/lib/contentParsers/contentItemTypeGuards";
import {
  CTA_TYPE_BUTTON,
  CTA_TYPE_BUTTON_OVERLAY,
  CTA_TYPE_CONDITIONAL_CTA,
  isCtaSectionType,
  type CtaSectionType,
} from "@/types/contentSectionType";

export type CtaIndexFields = CtaFieldSink & {
  ctaTypes: CtaSectionType[];
  ctaCount: number;
};

const createEmptyCtaIndexFields = (): CtaIndexFields => ({
  ctaTypes: [],
  ctaKeys: [],
  ctaTexts: [],
  redirectTos: [],
  redirectServiceSnippets: [],
  ctaCount: 0,
});

const indexCtaItem = (item: ContentItem, acc: CtaIndexFields): void => {
  if (!isCtaSectionType(item.type)) {
    return;
  }
  acc.ctaTypes.push(item.type);
  switch (item.type) {
    case CTA_TYPE_BUTTON:
      if (isButtonContentItem(item)) {
        appendCtaKeyAndText(acc, item.key, item.text);
        appendRedirectFields(acc, item);
      }
      break;
    case CTA_TYPE_BUTTON_OVERLAY:
      if (isButtonOverlayContentItem(item)) {
        appendCtaKeyAndText(acc, item.key, item.text);
      }
      break;
    case CTA_TYPE_CONDITIONAL_CTA:
      if (isConditionalCtaContentItem(item)) {
        for (const opt of item.options) {
          collectNestedCtaFields(acc, opt.cta);
        }
      }
      break;
  }
};

export const collectCtaIndexFields = (
  content: ContentItem[],
): CtaIndexFields => {
  const acc = createEmptyCtaIndexFields();
  for (const item of content) {
    indexCtaItem(item, acc);
  }
  acc.ctaCount = acc.ctaTypes.length;
  return acc;
};
